module.exports = __webpack_public_path__ + "static/img/team_2.82d101e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team_2.png
// module id = TDpA
// module chunks = 1